import Dexie from 'dexie';
import config from '../config/config';
import { setItemInLocalStorage } from 'utils/helpers';

const db = new Dexie(config.indexDbDatabaseName);

db.version(2).stores({
  [config.indexDbDomesticTableName]: '++id',
  [config.indexDbGlobalTableName]: '++id',
  [config.indexDbSocialScreenerTableName]: '++id',
});

export const getCompaniesDataFromIndexDb = async tableName => {
  try {
    return await db.table(tableName).toArray();
  } catch {
    return [];
  }
};

export const overrideCompaniesDataInIndexDb = async (tableName, data, localStorageKey) => {
  try {
    const tableNames = await db.tables?.map(table => table.name);
    if (tableNames?.includes(tableName)) {
      await db[tableName].clear(); // clear existing data
    }
    await db[tableName].bulkAdd(data); // add data in indexDb in bulk

    if (localStorageKey) setItemInLocalStorage(localStorageKey, new Date(), false);
  } catch (error) {
    console.log(error);
  }
};

export const updateTickerStatusInDomesticIndexDB = async (companyId, status) => {
  try {
    const storedCompanies = await getCompaniesDataFromIndexDb(config.indexDbDomesticTableName);

    const matchingCompanies = storedCompanies.filter(c => c.companyId === companyId);

    if (matchingCompanies.length) {
      const updatedCompanies = matchingCompanies.map(company => ({
        ...company,
        isTickerActive: status,
      }));

      await db[config.indexDbDomesticTableName].bulkPut(updatedCompanies);
    }
  } catch (error) {
    console.log('error', error);
  }
};
